import React from "react";
import { OptionsPopover } from "ui/components";
import { Option } from "core/models";

interface Props {
    disabled: boolean;
    handleDownload(type: "vtt" | "srt"): void;
}

const SubtitlesDownloadMenu: React.FC<Props> = ({
    disabled,
    handleDownload,
}) => {
    const downloadOptions: Option[] = [
        {
            title: "Download .VTT",
            icon: "download",
            onClick: () => handleDownload("vtt"),
        },
        {
            title: "Download .SRT",
            icon: "download",
            onClick: () => handleDownload("srt"),
        },
    ];
    return (
        <OptionsPopover
            icon="download"
            options={downloadOptions}
            disabled={disabled}
            orientation="left"
            buttonType="icon"
        />
    );
};

export default SubtitlesDownloadMenu;
